module.exports = __webpack_public_path__ + "assets/ubike3.jpg?81a9decc3e1f7abf07f63e9513271177";